import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import configureStore from 'store/configureStore'
import App from './App'
import FleetOauthBounce from 'pages/directCob/FleetOauthBounce'
import { isFleetOauthReturnWindow } from 'pages/directCob/fleetOauthReturn'
import './App.scss'

const store = configureStore()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  isFleetOauthReturnWindow(window) ? (
    <FleetOauthBounce />
  ) : (
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  )
)
